import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import CadminApi            from 'app/apis/company-admin';
import Modal                from 'app/components/common/modal';
import StripePaymentElement from 'app/components/company-admin/wallet/stripe-payment-element';
import config               from 'app/config';
import AuthSlx              from 'app/selectors/auth';
import CadminSlx            from 'app/selectors/company-admin/';

const isDev = config.millieEnv === 'development';

class ModalNewBankAccount extends React.PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      clientSecret: null,
    };

    this.onCloseModal = this.onCloseModal.bind(this);
  }

  componentDidMount() {
    CadminApi.walletCreateStripeSetupIntent(this.props.company.id).then(({clientSecret}) => {
      this.setState({clientSecret});
    });
  }

  onCloseModal() {
    this.props.onClose();
  }

  get employee() {
    return this.props.currentUser.employment.employee;
  }
  get name() {
    return this.props.company?.name || '';
  }
  get email() {
    return isDev ? 'tyler+test_email@milliegiving.com' : this.employee.email;
  }

  render() {
    const {clientSecret} = this.state;

    return (
      <Modal onClose={this.onCloseModal} className="bform">
        <h1 className="bform-h1">Add Bank Account</h1>
        {isDev && <p className="notice">Use ngrok for this.</p>}
        <p className="notice">Note: Use the account holder name for the "Full name" field.</p>
        {!!clientSecret && (
          <StripePaymentElement clientSecret={clientSecret} key={clientSecret} name={this.name} email={this.email} />
        )}
      </Modal>
    );
  }

}

ModalNewBankAccount.propTypes = {};
ModalNewBankAccount.defaultProps = {};

const stateToProps = (state) => ({
  currentUser: AuthSlx.currentUser(state),
  company: CadminSlx.company(state),
});

const dispatchToProps = (dispatch) => ({

});

export default connect(stateToProps, dispatchToProps)(ModalNewBankAccount);
